import { render, staticRenderFns } from "./AiSearchModalContainer.vue?vue&type=template&id=1bc54f2c&"
import script from "./AiSearchModalContainer.vue?vue&type=script&lang=js&"
export * from "./AiSearchModalContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports